import { createFileRoute } from '@tanstack/react-router'
import { VerifyOtpForm } from '@/features/verify-otp-form'

export const Route = createFileRoute('/_login/login/forgot-password/verify-otp')({
  component: RouteComponent,
})

function RouteComponent() {
  return <VerifyOtpForm />
}
